import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PerimeterState } from './Types';

export const initialState: PerimeterState = {
  currentBrand: undefined,
  currentAgency: undefined,
};

const { reducer, actions } = createSlice({
  name: 'perimeter',
  initialState,
  reducers: {
    setCurrentBrand: (state, action: PayloadAction<PerimeterState['currentBrand']>) => {
      state.currentBrand = action.payload;
      state.currentAgency = action.payload?.agencies?.[0] ?? '';
    },
    setCurrentAgency: (state, action: PayloadAction<PerimeterState['currentAgency']>) => {
      state.currentAgency = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<PerimeterState>) => {
      state.regionId = action.payload.regionId;
      state.zoneId = action.payload.zoneId;
      state.branchId = action.payload.branchId;
    },
    resetCurrent: state => {
      state.currentBrand = undefined;
      state.currentAgency = undefined;
    },
  },
});

export const perimeterReducer = reducer;
export const perimeterActions = actions;
